var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    [
      _c("queueton-resource-status", {
        attrs: { resource: _vm.resource, "resource-id": _vm.resourceId },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (slotProps) {
              return [
                _c("span", [
                  _vm._v(
                    "\n        Queueton Status: " +
                      _vm._s(slotProps.status) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }